// A History list as the Settings board shows it under every editor: "when, who", then
// "Field: old to new". A change with no old value reads "Field: new".
export type HistoryItem = { when: string; field: string; before: string; after: string };

export function HistoryRows({ rows, empty }: { rows: HistoryItem[]; empty: string }) {
  return (
    <div className="mini">
      {rows.length === 0 ? (
        <div className="hrow muted">{empty}</div>
      ) : (
        rows.map((h, i) => (
          <div key={i} className="hrow">
            <span className="muted">{h.when}</span>
            <span className="ink">
              <b className="w6">{h.field}</b>:{' '}
              {h.before ? (
                <>
                  {h.before} <span className="faint">to</span> {h.after}
                </>
              ) : (
                h.after
              )}
            </span>
          </div>
        ))
      )}
    </div>
  );
}
